const BANK_ACCOUNT = {
   name: "STEPHANIE",
   bank: "Mandiri",
   no_rek: 1410024956864
}

export const globalVar = {
   bank_account: BANK_ACCOUNT
}